import { render, staticRenderFns } from "./businessList.vue?vue&type=template&id=6dafb01b&scoped=true"
import script from "./businessList.vue?vue&type=script&lang=js"
export * from "./businessList.vue?vue&type=script&lang=js"
import style0 from "./businessList.vue?vue&type=style&index=0&id=6dafb01b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dafb01b",
  null
  
)

export default component.exports